var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHytterLejrskoler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.525,7.374a.282.282,0,0,0-.359,0l-2.3,1.88a.164.164,0,0,0,.1.292h.386v2.666a.1.1,0,0,0,.1.1h.958a.1.1,0,0,0,.1-.1V10.625a.1.1,0,0,1,.1-.1h1.37a.1.1,0,0,1,.1.1v1.587a.1.1,0,0,0,.1.1h.958a.1.1,0,0,0,.1-.1V9.546h.495a.164.164,0,0,0,.1-.292Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9,7.374a.282.282,0,0,0-.359,0l-2.3,1.88a.164.164,0,0,0,.1.292H2.73v2.666a.1.1,0,0,0,.1.1h.958a.1.1,0,0,0,.1-.1V10.625a.1.1,0,0,1,.1-.1h1.37a.1.1,0,0,1,.1.1v1.587a.1.1,0,0,0,.1.1H6.5a.1.1,0,0,0,.1-.1V9.546h.5a.164.164,0,0,0,.1-.292Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.127,4.279h.385V6.945a.1.1,0,0,0,.1.1h.957a.1.1,0,0,0,.1-.1V5.358a.1.1,0,0,1,.1-.1H8.13a.1.1,0,0,1,.1.1V6.945a.1.1,0,0,0,.1.1H9.28a.1.1,0,0,0,.1-.1V4.279h.494a.165.165,0,0,0,.105-.292l-2.3-1.88a.281.281,0,0,0-.358,0l-2.3,1.88A.165.165,0,0,0,5.127,4.279Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.469,4.318a.027.027,0,0,1,.022-.041h.294a.1.1,0,0,0,.083-.143L12,2.625a.1.1,0,0,0-.165,0L10.96,4.134a.1.1,0,0,0,.083.143h.294a.028.028,0,0,1,.023.038L10.6,5.626a.1.1,0,0,0,.083.143h.955a.092.092,0,0,1,.092.092v1a.181.181,0,1,0,.361,0v-1a.1.1,0,0,1,.1-.1h.951a.1.1,0,0,0,.083-.143S12.478,4.332,12.469,4.318Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHytterLejrskoler);
export default __webpack_public_path__ + "static/media/HYTTER-LEJRSKOLER.943848920b199d8c354028284f843e5d.svg";
export { ForwardRef as ReactComponent };